export default {
  setValidCode(state, payload) {
    state.validCode = payload;
  },
  setProductIdsForValidCode(state, payload) {
    state.productIdsForValidCode = payload;
  },
};
